import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Mail, Phone, MessageCircle, Instagram, Facebook } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { CONTACT, TYPE_META } from "../lib/constants";

export default function Footer() {
  const { t, lang } = useI18n();
  const loc = useLocation();
  if (loc.pathname.startsWith("/admin")) return null;

  return (
    <footer className="bg-wostel-navy text-sand-50 mt-24" data-testid="site-footer">
      <div className="container-x py-20 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <div className="flex items-center gap-3 mb-6">
            <img src={TYPE_META.hostel.logo} alt="" className="h-12 w-12" />
            <div>
              <div className="font-serif text-2xl">Wostel Djerba</div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-sand-50/70">Tunisia</div>
            </div>
          </div>
          <p className="text-sand-50/80 max-w-sm leading-relaxed">{t.footer.tagline}</p>
          <p className="text-wostel-sun text-xs uppercase tracking-[0.25em] mt-6">{t.footer.partner}</p>
          <a href={CONTACT.sefertunisia} target="_blank" rel="noreferrer" data-testid="footer-sefer-link"
             className="inline-block mt-2 underline underline-offset-4 hover:text-wostel-sun text-sm">sefertunisia.com</a>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.25em] text-sand-50/60 mb-4">{t.footer.explore}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/stays" className="hover:text-wostel-sun" data-testid="footer-link-stays">{t.nav.stays}</Link></li>
            <li><Link to="/guides" className="hover:text-wostel-sun" data-testid="footer-link-guides">{t.nav.guides}</Link></li>
            <li><Link to="/creators" className="hover:text-wostel-sun" data-testid="footer-link-creators">{t.nav.creator}</Link></li>
            <li><Link to="/tours" className="hover:text-wostel-sun" data-testid="footer-link-tours">{t.legal.tour.title}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.25em] text-sand-50/60 mb-4">{t.footer.legal}</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/house-rules" className="hover:text-wostel-sun" data-testid="footer-link-rules">{t.legal.house.title}</Link></li>
            <li><Link to="/cancellation" className="hover:text-wostel-sun" data-testid="footer-link-cancel">{t.legal.cancel.title}</Link></li>
            <li><Link to="/privacy" className="hover:text-wostel-sun" data-testid="footer-link-privacy">{t.legal.privacy.title}</Link></li>
            <li><Link to="/terms" className="hover:text-wostel-sun" data-testid="footer-link-terms">{t.legal.terms.title}</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.25em] text-sand-50/60 mb-4">{t.footer.connect}</div>
          <ul className="space-y-3 text-sm">
            <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-wostel-sun" data-testid="footer-email"><Mail size={14}/> {CONTACT.email}</a></li>
            <li><a href={`tel:${CONTACT.phone.replace(/\s/g,'')}`} className="flex items-center gap-2 hover:text-wostel-sun" data-testid="footer-phone"><Phone size={14}/> {CONTACT.phone}</a></li>
            <li><a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-wostel-sun" data-testid="footer-whatsapp"><MessageCircle size={14}/> {CONTACT.whatsappPretty}</a></li>
            <li className="flex gap-3 pt-2">
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-wostel-sun" data-testid="footer-ig"><Instagram size={18}/></a>
              <a href={CONTACT.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="hover:text-wostel-sun" data-testid="footer-fb"><Facebook size={18}/></a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-sand-50/15">
        <div className="container-x py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-sand-50/60">
          <span>© {new Date().getFullYear()} Wostel Djerba. {t.footer.rights}</span>
          <span>@wosteldjerba · {lang === "fr" ? "Fait avec ❣ à Djerba" : "Made with ❣ in Djerba"}</span>
        </div>
      </div>
    </footer>
  );
}
